<div class="sidebar" [class.expanded]="isExpanded" (mouseleave)="onSidebarLeave($event)">
  <div class="sidebar-header">
    <div class="img-cnt">
      <img class="sidebar-sourceImg" (error)="imageLoadError($event)" [src]="neoPatIcon" alt="" />
    </div>
  </div>

  <div class="sidebar-content">
    <!-- Main group icons -->
    <div class="group-items main-groups">
      <button *ngFor="let group of mainGroups" class="icon-fun" #groupBtn
        (mouseenter)="onGroupHover(group.groupKey, groupBtn)" (mouseleave)="onGroupLeave()"
        (click)="isExpanded ? null : onGroupHover(group.groupKey, groupBtn)" [title]="group.label">
        <img [src]="group.icon" alt="" />
      </button>
    </div>

    <!-- Settings group at bottom -->
    <div class="sidebar-divider"></div>
    <div class="group-items settings-group">
      <button *ngFor="let item of settingsGroup" class="icon-fun" #settingsBtn
        (mouseenter)="onSettingsHover(settingsBtn)" (mouseleave)="onSettingsLeave()"
        (click)="onSettingsHover(settingsBtn)" [title]="item.label">
        <img [src]="item.icon" alt="" />
      </button>
      <button class="icon-fun" #announcementsBtn (mouseenter)="onAnnouncementsHover(announcementsBtn)"
        (mouseleave)="onAnnouncementsLeave()" (click)="onAnnouncementsHover(announcementsBtn)"
        [title]="'Announcements'">
        <img src="assets/sidebar/announcements.png" alt="Announcements" />
        <div *ngIf="hasRecentAnnouncements" class="announcement-indicator"></div>
      </button>
    </div>

    <div *ngIf="hoveredAnnouncements && !isExpanded"
      class="sidebar-float-menu custom-float-menu announcements-float-menu" (mouseenter)="onAnnouncementsMenuEnter()" (mouseleave)="onAnnouncementsMenuLeave()"
      [ngStyle]="{ top: announcementsMenuTop + 'px' }">
      <div class="float-group-title">Announcements</div>
      <div class="float-group-items">
        <div *ngFor="let ann of sidebarAnnouncements" class="announcement-banner" (click)="goToAnnouncement(ann.route)">
          <div class="banner-message">{{ ann.message }}</div>
          <div class="banner-date">{{ ann.date | date:'MMM d, h:mm a' }}</div>
        </div>
        <div *ngIf="sidebarAnnouncements.length === 0" class="float-menu-text">No announcements</div>
      </div>
    </div>

    <!-- Announcements group below settings -->
    <!-- <div class="group-items announcements-group" *ngIf="sidebarAnnouncements.length > 0">
      <button *ngFor="let ann of sidebarAnnouncements" class="icon-fun announcement-fun"
        (click)="goToAnnouncement(ann.route)" [title]="ann.message">
        <span class="announcement-message">{{ ann.message }}</span>
        <span class="announcement-time">{{ ann.date | date:'shortTime' }}</span>
      </button>
    </div>
  </div> -->

  <!-- Floating popout menu for main groups -->
  <div *ngIf="hoveredGroup && !isExpanded" class="sidebar-float-menu custom-float-menu"
    (mouseenter)="onFloatMenuEnter()" (mouseleave)="onFloatMenuLeave()" [ngStyle]="{ top: floatMenuTop + 'px' }">
    <ng-container *ngFor="let group of mainGroups">
      <div *ngIf="group.groupKey === hoveredGroup">
        <div class="float-group-title">{{ group.label }}</div>
        <div class="float-group-items">
          <!-- Show loading indicator when items are not loaded -->
          <div *ngIf="!isItemsLoaded" class="float-menu-loading">
            <div class="loading-spinner"></div>
            <span class="float-menu-text">Loading...</span>
          </div>
          <!-- Show items when loaded -->
          <button *ngFor="let opt of group.items" class="float-menu-item" (click)="navClick(opt)">
            <img [src]="opt.value" alt="" />
            <span class="float-menu-text">{{ opt.toolTip }}</span>
            <!-- <span *ngIf="opt.isBeta" class="float-beta-label">Beta</span> -->
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Floating popout menu for settings group -->
  <div *ngIf="hoveredSettings && !isExpanded" class="sidebar-float-menu custom-float-menu"
    (mouseenter)="onSettingsMenuEnter()" (mouseleave)="onSettingsMenuLeave()"
    [ngStyle]="{ top: settingsMenuTop + 'px' }">
    <ng-container *ngFor="let item of settingsGroup">
      <div *ngIf="item.popout">
        <div class="float-group-title">Settings</div>
        <div class="float-group-items">
          <button *ngFor="let opt of item.popout" class="float-menu-item" (click)="handleSettingsAction(opt.action)">
            <img [src]="opt.value" alt="" />
            <span class="float-menu-text">{{ opt.label }}</span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <!-- Remove the profile group floating menu since profile is now in header -->
</div>